import { RoleProps } from "modules/auth/role/store/actionType";

export enum actionTypes {
    LOGIN_REQUEST = 'LOGIN_REQUEST',
    LOGIN_SUCCESS = 'LOGIN_SUCCESS',
    LOGIN_FAIL = 'LOGIN_FAIL',
    RESET_AUTH = 'RESET_AUTH'
}

export enum stateStatusType {
    SUCCESS = 'SUCCESS',
    FAILED = 'FAILED'
}

export interface LoginProps {
    login_id: string;
    password: string;
}

export interface LoginErrorProps {
    login_id: string;
    password: string;
    general_error: string;
}
export interface UserProps {
    id: string;
    user_identifier: string;
    email?: string;
    name?: string;
    status?:string;
    mobile_no?: string;
    created_at: string;
    updated_at: string;
    roles: RoleProps[];
}

export interface TokenProps {
    refresh_token: string;
    expires_in: string;
    token_type: string;
    access_token:string;
}

export interface AuthUserProps {
    user: UserProps | null;
    token: TokenProps | null;
}

export interface LoginRequestAction {
    type: actionTypes.LOGIN_REQUEST;
}
export interface LoginSuccessAction {
    type: actionTypes.LOGIN_SUCCESS;
    payload: AuthUserProps;
}

export interface LoginFailAction {
    type: actionTypes.LOGIN_FAIL;
    payload: string;
}

export interface ResetAuthAction {
    type: actionTypes.RESET_AUTH;
}

export type LoginActions = LoginRequestAction | LoginSuccessAction | LoginFailAction |ResetAuthAction;
